import Layout from "~/layouts/ThemeLayout";
import SEOTags from "~/components/SEOTags";
import dynamic from "next/dynamic";

const TrackingOrder = dynamic(() => import("~/sections/TrackingOrder"), {
  ssr: false,
});
type Props = {};

const TrackOrder = (props: Props) => {
  return (
    <Layout contentContainerStyle={{ minHeight: 576 }}>
      <SEOTags title="Track Order" />

      <TrackingOrder />
    </Layout>
  );
};

export default TrackOrder;
